import { getDataOverviewFileDisplayName } from '@/features/datasets/utils/datasetCloneNames';

/** True when any upload slot has more than one file — each file gets its own details form. */
export function shouldSplitFileDetails({ datasetCount = 0, benchmarkCount = 0 } = {}) {
    return datasetCount > 1 || benchmarkCount > 1;
}

/**
 * Hide the "Data Details" heading and "share the same details" checkbox when a
 * benchmark is present alongside multiple train (dataset) files.
 */
export function shouldHideShareDetailsToggle({ datasetCount = 0, hasBenchmark = false } = {}) {
    return Boolean(hasBenchmark && datasetCount > 1);
}

/** Heading above a per-file details form, e.g. `Dataset(1): train.csv`. */
export function fileDetailsHeading(kind, index, fileName) {
    const isBenchmark = String(kind || '').toLowerCase() === 'benchmark';
    const label = isBenchmark ? 'Benchmark' : 'Dataset';
    const name = fileName ? ` ${fileName}` : '';
    return `${label}(${index}):${name}`;
}

/** User-facing file name for a pending or uploaded slot entry. */
export function fileDisplayName(entry) {
    if (!entry) return '';
    const raw =
        entry.file?.name ||
        entry.uploadName ||
        entry.librarySourceName ||
        entry.datasetName ||
        entry.huggingFaceDatasetId ||
        '';
    if (!raw) return '';
    return getDataOverviewFileDisplayName(raw) || raw;
}
